import React from "react";

import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

import "./TopNav.css";


const Nav = () => {

    return (

        <div className="top-nav">

            <div className="container">

                <div className="top-nav-wrapper">


                    {/* Contact */}

                    <div className="contact-info">


                        <a href="mailto:contact@eternicabeauty.com">

                            <EmailIcon />

                            <span>
                                contact@eternicabeauty.com
                            </span>

                        </a>



                        <a href="tel:+971523987292">

                            <PhoneIcon />

                            <span>
                                +971 52 398 7292
                            </span>

                        </a>


                    </div>





                    {/* Social - Desktop Only */}

                    <div className="social-icons">


                        <a href="#" aria-label="Facebook">
                            <FacebookIcon />
                        </a>


                        <a href="#" aria-label="Twitter">
                            <TwitterIcon />
                        </a>


                        <a href="#" aria-label="Instagram">
                            <InstagramIcon />
                        </a>


                        <a href="#" aria-label="LinkedIn">
                            <LinkedInIcon />
                        </a>


                    </div>


                </div>

            </div>

        </div>

    );

};


export default Nav;